import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import ToggleSwitch from '../toggle-switch/toggle-switch-component';
import Input from '../input/input-component';
import Styled from './accordion-input.style';

/**
 * AccordionInput component
 * @param {object} props - The props for the AccordionInput component
 * @param {string} props.accordionName - The name of the accordion
 * @param {string} props.selectedSymbol - The selected symbol
 * @param {string} props.accordionLabel - The label of the accordion
 * @param {string} props.inputName - The name of the input
 * @param {string} props.inputLabel - The label of the input
 * @param {string} props.inputType - The type of the input
 * @param {object} props.registerOptions - The register options
 * @returns {JSX.Element} The AccordionInput component
 */
const AccordionInput = ({
  accordionName,
  accordionLabel,
  inputName,
  inputLabel,
  inputType,
  selectedSymbol,
  registerOptions,
}) => {
  const { watch } = useFormContext();

  const open = watch(accordionName);

  return (
    <>
      <Styled.AccordionHeader>
        <h2>{accordionLabel}</h2>
        <ToggleSwitch name={accordionName} />
      </Styled.AccordionHeader>
      {open && (
        <Input
          name={inputName}
          label={inputLabel}
          type={inputType}
          iconLeft={selectedSymbol}
          registerOptions={registerOptions}
        />
      )}
    </>
  );
};

AccordionInput.propTypes = {
  accordionName: PropTypes.string.isRequired,
  accordionLabel: PropTypes.string.isRequired,
  inputName: PropTypes.string.isRequired,
  inputLabel: PropTypes.string.isRequired,
  inputType: PropTypes.string.isRequired,
  selectedSymbol: PropTypes.string.isRequired,
  registerOptions: PropTypes.object.isRequired,
};

export default AccordionInput;
